<template>
    <a href="https://api.whatsapp.com/send?phone=51000000000&text=olá" class="wpp d-flex" target="_blank"
        style="">
        <div class="p-3 animacao" style="color: black !important;background-color: whitesmoke; border-radius:50px; justify-content: center; align-items: center;">
          Olá, Como Posso Te Ajudar ?
        </div>
        <img src="../assets/wpp.svg" alt="botão whatsapp">
        <span class="alerta-mensagem px-2">1</span>
    </a>
</template>
<script>

export default {
  name: 'Wpp',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
a{
  text-decoration: none;
  color: rgb(255, 255, 255);
}
.alerta-mensagem{
  background-color: red;
  height: fit-content;
  border-radius: 50%;
  margin-left: -18px;
}

.wpp{
    position: fixed;
    right: 15px;
    bottom: 75px;
    z-index: 999;
    transition: all ease 0.4s;
  }
.wpp:hover{
  transform: scale(1.1);
}
.animacao{
  transition: all ease 13s !important;
  display: none;
}
.wpp:hover > .animacao{
  display: flex !important;
}

</style>



// WEBPACK FOOTER //
// src/components/wpp.vue